// extracted by mini-css-extract-plugin
export default {"mainContainer":"CustomDetails_mainContainer__EHj83","headerContainer":"CustomDetails_headerContainer__VBWPe","dataContainer":"CustomDetails_dataContainer__nOKJB"};